import { RootState } from "@/store/store";
import { CommitmentCostBreakdown } from "@/services/cloudchipr.api";
import { azureOverviewDataSelector } from "@/store/commitments/selectors/azure/overview/azureOverviewDataSelector";

export const azureOverviewCoveredCostBreakdownSelector = (
  state: RootState,
): CommitmentCostBreakdown => {
  const data = azureOverviewDataSelector(state);

  return data?.covered_cost_breakdown ?? null;
};
